import {
  Box,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import backbluebtn from "../../../Utils/Images/backbluebtn.png";
import CustomButton from "../../../Components/Button/CustomButton";
import CustomInput from "../../../Components/input/CustomInput";
import { GetSingleCoupon } from "../../../APIs/Function/Coupon/Singlecoupon";
import { handleUpdateCoupon } from "../../../APIs/Function/Coupon/EditCoupon";
import Loader2 from "../../../Components/Loader/Loader2";

const EditCoupon = () => {
  const { id } = useParams();
  const [singleCoupon, setSingleCoupon] = useState({});
  const [discount_value, setDiscountValue] = useState("");
  const [discountValueOptions, setDiscountValueOptions] = useState();
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState([]);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    coupon_code: "",
    description: "",
    discount_type: "",
    discount_value: "",
  });

  const Arr = [
    {
      key: "10",
      value: "10",
    },
    {
      key: "20",
      value: "20",
    },
    {
      key: "30",
      value: "30",
    },
  ];
  const Arr2 = [
    {
      key: "100",
      value: "100",
    },
    {
      key: "200",
      value: "200",
    },
    {
      key: "300",
      value: "300",
    },
  ];

  const handleEditcoupon = async () => {
    try {
      let res = await GetSingleCoupon(id);
      setSingleCoupon(res.r);
      setLoading(true);
      setFormData({
        ...formData,
        coupon_code: res.r.coupon_code,
        description: res.r.description,
        discount_type: res.r.discount_type,
        discount_value: res.r.discount_value,
      });
      setDiscountValue(res.r.discount_value);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      formData.coupon_code.trim() !== "" &&
      formData.description.trim() !== "" &&
      formData.discount_type &&
      formData.discount_value
    ) {
      try {
        setLoading(true);
        await handleUpdateCoupon({ id, ...formData });
        setLoading(false);
        alert("Data Edited Succesfully");
        navigate("/coupon");
      } catch (error) {
        console.log(error);
      }
    } else {
      alert("Please Fill All The Fields Correctly");
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleDiscountTypeChange = (value) => {
    if (value === "1") {
      setDiscountValueOptions(["10", "20", "30"]); // Percentage options
    } else if (value === "2") {
      setDiscountValueOptions(["100", "200", "300"]); // Price options
    } else {
      setDiscountValueOptions([]); // Default options or no options
    }

    setFormData({
      ...formData,
      discount_type: value,
      discount_value: "",
    });
  };

  console.log("f", formData);

  useEffect(() => {
    handleEditcoupon();
  }, []);

  return (
    <>
      {loading ? (
        <Box sx={{ mt: "25%" }}>
          <Loader2 />
        </Box>
      ) : (
        <Box>
          {/* header */}
          <Box
            sx={{
              bgcolor: "#31AEF4",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: { xs: "50px", md: "70px", lg: "70px" },
              p: "10px",
              boxSizing: "border-box",
            }}
          >
            <Link to={`/coupon`}>
              <Box
                sx={{
                  height: { xs: "50px", md: "60px", lg: "60px" },
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img height={"100%"} src={backbluebtn} alt="back" />
              </Box>
            </Link>
            <Box>
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontSize: { md: "30px", sm: "20px" },
                  fontWeight: 600,
                  lineHeight: "36px",
                  color: "#FFFFFF",
                }}
              >
                Edit Coupon
              </Typography>
            </Box>
            <Box>
              <CustomButton
                onClick={handleSubmit}
                sx={{
                  width: { xs: "40px", md: "50px", lg: "80px" },
                  height: { xs: "10px", md: "50px", lg: "50px " },
                }}
              >
                {loading ? <CircularProgress></CircularProgress> : "Save"}
              </CustomButton>
            </Box>
          </Box>
          <Box
            sx={{
              p: 2,
              boxSizing: "border-box",
              display: "flex",
              justifyContent: "center ",
            }}
          >
            {/* Form */}

            <Box sx={{ width: "45%" }}>
              <Container maxWidth="sm" sx={{ mt: "10px" }}>
                <form>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <CustomInput
                        label="Coupon Code"
                        name="coupon_code"
                        value={formData.coupon_code}
                        onChange={handleInputChange}
                        fullWidth
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CustomInput
                        label="Description"
                        name="description"
                        value={formData?.description}
                        onChange={handleInputChange}
                        fullWidth
                        multiline
                        rows={4}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} sx={{ mt: "15px" }}>
                      <FormControl fullWidth required>
                        <InputLabel
                          sx={{
                            bgcolor: "#fff",
                          }}
                        >
                          Discount Type
                        </InputLabel>
                        <Select
                          name="discount_type"
                          value={formData.discount_type}
                          onChange={(e) =>
                            handleDiscountTypeChange(e.target.value)
                          }
                          sx={{ textAlign: "left" }}
                        >
                          <MenuItem value="1">Percentage</MenuItem>
                          <MenuItem value="2">Price</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    {formData.discount_type && ( // Conditional rendering of discount_value field
                      <Grid item xs={12} sx={{ mt: "15px" }}>
                        <FormControl fullWidth required>
                          <InputLabel
                            sx={{
                              bgcolor: "#fff",
                            }}
                          >
                            Discount Value
                          </InputLabel>
                          <Select
                            name="discount_value"
                            value={formData.discount_value}
                            onChange={handleInputChange}
                            sx={{ textAlign: "left" }}
                          >
                            {formData.discount_type == "1"
                              ? Arr.map((option, index) => (
                                  <MenuItem key={index} value={option.value}>
                                    {option.key}
                                  </MenuItem>
                                ))
                              : Arr2.map((option, index) => (
                                  <MenuItem key={index} value={option.value}>
                                    {option.key}
                                  </MenuItem>
                                ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    )}
                  </Grid>
                </form>
              </Container>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default EditCoupon;
